/* eslint-disable react/no-children-prop */

/**
 * App router
 */

// React
import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Pages
import Home from 'pages/Home';
import ErrorPage from 'pages/Error';
import NotFoundPage from 'pages/404';
import UserInfo from 'pages/UserInfo';
import EditSystems from 'pages/EditSystems';
import DigitalSurvey from 'pages/DigitalSurvey';
import AudioAnalysis from 'pages/AudioAnalysis';
import PeopleMeasurement from 'pages/PeopleMeasurement';
import SettingContentSystem from 'pages/SettingContentSystem';
import SystemApplicationSetting from 'pages/SystemApplicationSetting';
import SystemApplicationStatusCheck from 'pages/SystemApplicationStatusCheck';

// Router
import ROUTES from 'configs/route';
import AuthRoute from './AuthRoute';
import PrivateRoute from './PrivateRoute';

const AppRouter: React.FC = () => (
  <Routes>
    <Route path={ROUTES.HOME} element={<AuthRoute children={<Home />} />} />
    <Route
      path={ROUTES.EDIT_SYSTEMS}
      element={<PrivateRoute children={<EditSystems />} showFooter={false} showHeader={false} />}
    />
    <Route path={ROUTES.USER_INFO} element={<PrivateRoute children={<UserInfo />} />} />
    <Route
      path={ROUTES.PEOPLE_MEASUREMENT}
      element={<PrivateRoute children={<PeopleMeasurement />} />}
    />
    <Route path={ROUTES.AUDIO_ANALYSIS} element={<PrivateRoute children={<AudioAnalysis />} />} />
    <Route
      path={ROUTES.SYSTEM_APPLICATION_SETTING}
      element={<PrivateRoute children={<SystemApplicationSetting />} />}
    />
    <Route
      path={ROUTES.SYSTEM_APPLICATION_STATUS_CHECK}
      element={<PrivateRoute children={<SystemApplicationStatusCheck />} />}
    />
    <Route
      path={ROUTES.SETTING_CONTENT_SYSTEM}
      element={
        <PrivateRoute children={<SettingContentSystem />} showFooter={false} showHeader={false} />
      }
    />
    <Route path={ROUTES.DIGITAL_SURVEY} element={<PrivateRoute children={<DigitalSurvey />} />} />
    <Route path={ROUTES.ERROR} element={<ErrorPage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRouter;
